import type { NotificationBroadcastObservationCommentedPayload } from "../notification-broadcast.type";

import { isValidObject } from "@/utilities/object";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import {
  isNotificationBroadcastNamedModel,
  isValidNotificationBroadcastBase,
} from "../notification-broadcast.helper";

export const isNotificationBroadcastObservationCommentedPayload = (
  payload: unknown
): payload is NotificationBroadcastObservationCommentedPayload =>
  isValidNotificationBroadcastBase(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.OBSERVATION_COMMENTED &&
  "intervention" in payload &&
  isNotificationBroadcastNamedModel(payload.intervention) &&
  "observation" in payload &&
  isNotificationBroadcastNamedModel(payload.observation) &&
  "comment" in payload &&
  isValidObject(payload.comment) &&
  "id" in payload.comment &&
  typeof payload.comment.id === "number" &&
  "author_name" in payload.comment &&
  typeof payload.comment.author_name === "string" &&
  "content" in payload.comment &&
  typeof payload.comment.content === "string";
